import { APP, WS_DATA } from './app.constants';

export const DOCUMENTS = `${APP}_documents`;

// Full Document[] of the account, pushed after every upload/delete and on the initial data load
export const WS_DATA_DOCUMENTS = `${WS_DATA}/documents`;

export const DOCUMENTS_CHANGED = `${DOCUMENTS}/DOCUMENTS_CHANGED`;
